






















import { Component, Vue, Prop } from 'vue-property-decorator';
import Modal from '@/components/common/Modal.vue';
import SignupNew from '@/components/common/SignupNew.vue';
import TitleContainer from '@/components/common/TitleContainer.vue';

@Component({
  components: {
    Modal,
    SignupNew,
    TitleContainer,
  },
})
export default class ModalRegister extends Vue {
  @Prop()
  showRegister!: boolean;

  @Prop()
  closeRegister!: () => void;

  @Prop({ default: false })
  isPromo!: boolean;

  @Prop()
  customTitle!: string;

  @Prop()
  customDescription!: string;

  promoTitle = [
    {
      type: 'highlight',
      value: 'Signup',
    },
    {
      type: 'normal',
      value: 'with us first! It is FREE',
    },
  ];

  promoP = `By signing up, you would be able to <span class="bg-red-300 text-red-100">browse more questions</span>, collect questions, and generate PDF for your exam papers.`;

  get title() {
    const title = 'Sign up with us and start creating exam papers';
    const promoTitle = '';
    return this.isPromo
      ? promoTitle
      : this.customTitle
      ? this.customTitle
      : title;
  }

  get description() {
    const description = `You can add this question to a collection and a collection is a place where you can collect a lot of questions
                          and there you can generate PDF for your exam papers. But first, you need to sign up to create a collection.`;

    const promoDescription = ``;

    return this.isPromo
      ? promoDescription
      : this.customDescription
      ? this.customDescription
      : description;
  }

  width = '800px';
}
